import { cartAtom } from 'src/state/cart/cartAtom';
import { configurationAtom } from '@repo/widget-utils/widgetsConfiguration';
import { LocaleOverrideType, overrideLocale } from '@repo/i18n';
import { customizationAtom } from '../../components/utils/theme/customizations';
import { ThemeType } from '../../components/utils/theme/ThemeType';
import { BilberryWidgetsGlobal } from '@repo/types';
import { debugLog } from '@repo/common-utils/Logger';
import { showBasketAtom } from 'src/state/ui/showBasket.atom';

declare const window: any;

window.BilberryWidgetsGlobalOverride = function (configurations: Partial<BilberryWidgetsGlobal>) {
    debugLog('BilberryWidgetsGlobalOverride called with', configurations);
    cartAtom.update({ type: 'CLEAR' });
    configurationAtom.update({
        ...(configurationAtom.subject.value ?? {}),
        ...configurations,
    });
};

window.BilberryOverrideLanguage = function (locale: string) {
    overrideLocale(locale, LocaleOverrideType.JS_OVERRIDE);
};

window.BilberryOverrideTheme = function (customizations: Partial<ThemeType>) {
    customizationAtom.update({ ...customizationAtom.subject.value, ...customizations });
};

// Tooling hook: lets the test-site dev drawer read the bundle's current theme so
// it can capture a baseline and propagate field resets live (without this, resets
// would only take effect on the next page reload). No production-runtime impact.
window.BilberryCustomizationAtom = customizationAtom;

window.BilberryActions = {
    openBasket: () => {
        showBasketAtom.update({ visible: true });
    },
    closeBasket: () => {
        showBasketAtom.update({ visible: false });
    },
    toggleBasket: () => {
        const currentState = showBasketAtom.subject.value;
        showBasketAtom.update({ visible: !currentState.visible });
    },
    clearCart: () => {
        cartAtom.update({ type: 'CLEAR' });
    },
    getItemCount: () => {
        return cartAtom.subject.value.length;
    },
};
